import { styled } from '@mend/mui';
import { Link } from '@mui/material';
import { useSearchParams } from 'react-router';

import logoUrl from '#assets/logo-48.png';
import {
  Description as StatusMessageDescription,
  Root as StatusMessageRoot,
} from '#components/StatusMessage.tsx';
import { config } from '#config.ts';
import { sessionEndedReason } from '#services/mia-session.ts';

const Logo = styled('img')({ display: 'block' });

function PortalLink(props: { children: React.ReactNode }) {
  return (
    <Link href={config.PORTAL_BASE_URL} target="_blank">
      {props.children}
    </Link>
  );
}

export function Login() {
  const [searchParams] = useSearchParams();
  const hasSessionEnded = searchParams.get('reason') === sessionEndedReason;

  return (
    <StatusMessageRoot
      title="Sign in required"
      description={
        hasSessionEnded ? (
          <StatusMessageDescription>
            Your session has ended. Please sign in again to <PortalLink>Mend</PortalLink> to access
            Signal.
          </StatusMessageDescription>
        ) : (
          <StatusMessageDescription>
            Please sign in to <PortalLink>Mend</PortalLink> to access Signal.
          </StatusMessageDescription>
        )
      }
      icon={
        <PortalLink>
          <Logo src={logoUrl} alt="Mend" width={48} height={48} />
        </PortalLink>
      }
    />
  );
}
